export const getSessionStorage = function (key) {
  return window.sessionStorage.getItem(key)
}

export const setSessionStorage = function (key, value) {
  window.sessionStorage.setItem(key, value)
}

export const delSessionStorage = function (key) {
  window.sessionStorage.setItem(key, '')
}
